export const imports = {
  form: {
    clickOrDrag: 'ここにファイルをドロップしてアップロード',
  },
  pageHeader: {
    title: 'CSV インポート',
  },
}
